import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { MODIFY_GAME_PLATFORMS } from 'root/src/shared/descriptions/endpoints/endpointIds'

export default gamePlatforms => async (dispatch) => {
	const payload = { gamePlatforms }
	await dispatch(apiRequest(MODIFY_GAME_PLATFORMS, payload))
}
